<script setup lang="ts">
const props = defineProps({
  showDetail: { type: Boolean, default: false }
})
</script>

<template>
  <tr>
    <th class="border-bottom-grey" style="width: 3%" v-if="!showDetail"></th>
    <th class="border-bottom-grey pl-1" style="width: 18%">Name</th>
    <th class="border-bottom-grey pl-4" style="width: 12%">Type</th>
    <th class="border-bottom-grey text-center px-1" style="width: 10%">Mooring side</th>
    <th class="border-bottom-grey text-center px-1" style="width: 8%">
      Capacity <br />
      [varies]
    </th>
    <th class="border-bottom-grey text-center px-1" style="width: 10%">
      Length overall <br />
      [m]
    </th>
    <th class="border-bottom-grey text-center px-1" style="width: 10%">
      Breadth/beam <br />
      [m]
    </th>
    <th class="border-bottom-grey text-center px-1" style="width: 12%">
      Laden draught <br />
      [m]
    </th>
    <th class="border-bottom-grey text-center px-1" style="width: 13%">
      Laden displacement <br />
      [m<sup>3</sup>]
    </th>
    <th class="border-bottom-grey text-center px-1" style="width: 8%" v-if="!showDetail">
      Validation
    </th>
    <th class="border-bottom-grey text-center px-1" style="width: 8%" v-if="!showDetail">
      Actions
    </th>
  </tr>
</template>
